import { ServerFetch } from '../main-model'

export default class StockIssueListModel extends ServerFetch {
    getStockIssueListBy = (data) => this.authFetch({
        url: 'stock-issue-list/getStockIssueListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}